import { defineMessages } from '@edx/frontend-platform/i18n';
const messages = defineMessages({
  didYouMeanAlertText: {
    id: 'did.you.mean.alert.text',
    defaultMessage: 'Did you mean',
    description: 'Did you mean alert suggestion'
  },
  emptyEmailFieldError: {
    id: 'empty.email.field.error',
    defaultMessage: 'Email is required',
    description: 'Error message for empty email field'
  },
  emailInvalidFormaterror: {
    id: 'email.invalid.format.error',
    defaultMessage: 'Enter a valid email address',
    description: 'Validation error for invalid email address'
  }
});
export default messages;
//# sourceMappingURL=messages.js.map